import { Box } from "@mui/material";

export default function FormCaption() {
  return (
    <Box className="text-blue-900 text-xxl leading-5 font-bold pb-6">
      Sign up and get free access to Paved today
    </Box>
  );
}
